import { render, staticRenderFns } from "./taskFeedback.vue?vue&type=template&id=4844f690&scoped=true&"
import script from "./taskFeedback.vue?vue&type=script&lang=js&"
export * from "./taskFeedback.vue?vue&type=script&lang=js&"
import style0 from "./taskFeedback.vue?vue&type=style&index=0&id=4844f690&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4844f690",
  null
  
)

component.options.__file = "taskFeedback.vue"
export default component.exports